// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2_GDw","productName":"Table_productName__1pwZP"};